import { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { translationKeys } from "../../../../models/app-translation-keys";
import { useTermsOfUseService } from "../../../../services/ServiceHooks/termsOfUseHook";
import { TextMarkdown } from "../../../Shared/Components";
import { AddTermsOfUseButton } from "./AddTermsOfUseButton/AddTermsOfUseButton";
import TermsOfUseTable, { ITermsOfUse } from "./TermsOfUseTable/TermsOfUseTable";

import "./TermsOfUseTab.scss";

import { ManageTermsOfUseDialog } from "./ManageTermsOfUseDialog/ManageTermsOfUseDialog";

const TermsOfUseTab: FunctionComponent = () => {
  const { t } = useTranslation();

  const termsOfUseService = useTermsOfUseService();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [terms, setTerms] = useState<ITermsOfUse[]>([]);

  const [selectedTerms, setSelectedTerms] = useState<ITermsOfUse | null>(null);
  const [isEditDialogVisible, setIsEditDialogVisible] = useState(false);

  const touTranslationKeys = translationKeys.adminArea.termsOfUse;

  const requestTerms = async () => {
    try {
      setIsLoading(true);
      const response = await termsOfUseService.getAllTermsOfUse();
      setTerms(response);
    } finally {
      setIsLoading(false);
    }
  };

  const removeEntryFromTable = async (entry: ITermsOfUse) => {
    try {
      setIsLoading(true);
      await termsOfUseService.deleteTermsOfUse(entry.id);
      setTerms(prev => prev.filter(x => x.id !== entry.id));
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditClose = (success: boolean) => {
    setIsEditDialogVisible(false);
    setSelectedTerms(null);

    if (success) {
      requestTerms();
    }
  };

  useEffect(() => {
    requestTerms();
  }, []);

  return (
    <div className="terms-of-use-tab">
      {isEditDialogVisible && selectedTerms && (
        <ManageTermsOfUseDialog isVisible={isEditDialogVisible} onHide={handleEditClose} />
      )}

      <div className="terms-of-use-header">
        <h1>{t(touTranslationKeys.tab.header)}</h1>

        <TextMarkdown>{t(touTranslationKeys.tab.descriptionMarkdown)}</TextMarkdown>
      </div>

      <div className="termsofuse">
        <div className="termsofuse-controls">
          <AddTermsOfUseButton onUploadCompleted={requestTerms} />
        </div>

        <TermsOfUseTable
          terms={terms}
          isLoading={isLoading}
          onReloadTable={requestTerms}
          onDeleteEntry={removeEntryFromTable}
        />
      </div>
    </div>
  );
};

export default TermsOfUseTab;
